import swishQR from '../styling/images/swish-QR-small.png'
import "../styling/payment.css"
import { strings } from '../strings'

const Payment = () => {

    return (
        <div className='payment-container'>
            <p className="payment-info">{strings.payment.firstInfoString}</p>
            <p className="payment-info">{strings.payment.secondInfoString}</p>
            <img className="qr-image" src={swishQR} alt='swishQRcode' />
        </div>
    )

}

export default Payment